export default [
    {
        path: '/admin',
        name: 'AdminDashboard',
        component: () => import(/* webpackChunkName: "about" */ '../../views/sadmin/Dashboard.vue')
    },
    {
        path: '/admin/contacts',
        name: 'AdminContacts',
        component: () => import(/* webpackChunkName: "about" */ '../../views/sadmin/Contacts.vue')
    },
    {
        path: '/admin/users',
        name: 'AdminUsers',
        component: () => import(/* webpackChunkName: "about" */ '../../views/sadmin/Users.vue')
    },
    {
        path: '/admin/payments',
        name: 'AdminPayments',
        component: () => import(/* webpackChunkName: "about" */ '../../views/sadmin/Payments.vue')
    },
]